// Shared helpers for hierarchical (up to 4 levels) catalog categories/subcategories.

export const MAX_CATEGORY_DEPTH = 4;

// Returns a flat, depth-ordered list ready for rendering a <select> with indentation.
export function buildCategoryOptions(categories) {
  const byParent = {};
  categories.forEach(c => {
    const key = c.parent_id || 'root';
    if (!byParent[key]) byParent[key] = [];
    byParent[key].push(c);
  });
  const result = [];
  const walk = (parentKey, depth) => {
    (byParent[parentKey] || [])
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .forEach(c => {
        result.push({ ...c, depth });
        walk(c.id, depth + 1);
      });
  };
  walk('root', 0);
  return result;
}

// Breadcrumb string, e.g. "Audio › Auriculares › Bluetooth"
export function getCategoryPath(categories, categoryId) {
  if (!categoryId) return '';
  const map = {};
  categories.forEach(c => { map[c.id] = c; });
  const parts = [];
  let current = map[categoryId];
  let guard = 0;
  while (current && guard < MAX_CATEGORY_DEPTH + 2) {
    parts.unshift(current.name);
    current = current.parent_id ? map[current.parent_id] : null;
    guard++;
  }
  return parts.join(' › ');
}

// How many levels deep a NEW category under parentId would sit (root = 1).
export function categoryDepth(categories, parentId) {
  if (!parentId) return 1;
  const map = {};
  categories.forEach(c => { map[c.id] = c; });
  let depth = 1;
  let current = map[parentId];
  let guard = 0;
  while (current && guard < MAX_CATEGORY_DEPTH + 2) {
    depth++;
    current = current.parent_id ? map[current.parent_id] : null;
    guard++;
  }
  return depth;
}

// A category node + all its descendant ids (used to include subcategory products
// when a parent category is selected as a filter).
export function getDescendantIds(categories, categoryId) {
  const byParent = {};
  categories.forEach(c => {
    const key = c.parent_id || 'root';
    if (!byParent[key]) byParent[key] = [];
    byParent[key].push(c);
  });
  const ids = [categoryId];
  const collect = (id) => {
    (byParent[id] || []).forEach(child => {
      ids.push(child.id);
      collect(child.id);
    });
  };
  collect(categoryId);
  return ids;
}

// Build a parent -> [children] map for recursive tree rendering.
export function buildCategoryTree(categories) {
  const byParent = {};
  categories.forEach(c => {
    const key = c.parent_id || 'root';
    if (!byParent[key]) byParent[key] = [];
    byParent[key].push(c);
  });
  return byParent;
}
